import BigNumber from "vendor/bignumber.js/bignumber";

export default function(a: BigNumber, b: BigNumber) {
    return a.gt(b) ? a.minus(b) : new BigNumber(0);
}
